"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IBPayCardLimitsSchema = void 0;
var _zod = require("zod");
var IBPayCardLimitsSchema = t => {
  var schema = _zod.z.object({
    creditLimit: _zod.z.boolean(),
    creditLimitNumber: _zod.z.string().optional(),
    usageRestriction: _zod.z.boolean(),
    startDate: _zod.z.date().optional(),
    endDate: _zod.z.date().optional()
  });
  var validation = (data, setError, clearErrors) => {
    var hasErrors = false;
    if (data.creditLimit) {
      var _data$creditLimitNumb;
      var limitNumber = Number(data.creditLimitNumber);
      if (!(data !== null && data !== void 0 && (_data$creditLimitNumb = data.creditLimitNumber) !== null && _data$creditLimitNumb !== void 0 && _data$creditLimitNumb.trim() && !isNaN(limitNumber) && limitNumber >= 0 && Number.isInteger(limitNumber))) {
        hasErrors = true;
        setError('creditLimitNumber', {
          type: 'manual',
          message: t('cards.cardMgmt.cardDetails.limits.currency.error')
        });
      } else {
        clearErrors('creditLimitNumber');
      }
    }
    if (data.usageRestriction && !data.startDate) {
      hasErrors = true;
      setError('startDate', {
        type: 'manual',
        message: t('cards.cardMgmt.cardDetails.limits.date.error')
      });
    } else {
      clearErrors('startDate');
    }
    if (data.usageRestriction && !data.endDate) {
      hasErrors = true;
      setError('endDate', {
        type: 'manual',
        message: t('cards.cardMgmt.cardDetails.limits.date.error')
      });
    } else {
      clearErrors('endDate');
    }
    return !hasErrors;
  };
  return {
    schema,
    validation
  };
};
exports.IBPayCardLimitsSchema = IBPayCardLimitsSchema;